const BUY_SIDE = "buy";
const SELL_SIDE = "sell";

function toPremiumNumber(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
}

function normalizePhase(phase) {
  const value = String(phase || "")
    .trim()
    .toLowerCase();
  if (["current", "close", "closing", "exit"].includes(value)) return "exit";
  return "entry";
}

function normalizeDirectionSide(direction) {
  const value = String(direction || "")
    .trim()
    .toLowerCase();
  const firstLeg = value.split("/")[0].trim();
  if (firstLeg.startsWith(BUY_SIDE)) return BUY_SIDE;
  if (firstLeg.startsWith(SELL_SIDE)) return SELL_SIDE;
  return SELL_SIDE;
}

function getOppositeSide(side) {
  return side === BUY_SIDE ? SELL_SIDE : BUY_SIDE;
}

function formatPremiumValue(value, fallback = "—") {
  const number = toPremiumNumber(value);
  return number === null ? fallback : number.toFixed(2);
}

export function getPremiumPrimarySide(direction, phase = "entry") {
  const entrySide = normalizeDirectionSide(direction);
  return normalizePhase(phase) === "exit" ? getOppositeSide(entrySide) : entrySide;
}

export function buildPremiumPairValues({
  direction,
  phase = "entry",
  primaryPremium,
  buyPremium,
  sellPremium,
}) {
  const primarySide = getPremiumPrimarySide(direction, phase);
  const values = {
    buyPremium: toPremiumNumber(buyPremium),
    sellPremium: toPremiumNumber(sellPremium),
  };
  const primaryNumber = toPremiumNumber(primaryPremium);

  if (primaryNumber !== null) {
    const primaryKey = primarySide === BUY_SIDE ? "buyPremium" : "sellPremium";
    if (values[primaryKey] === null) values[primaryKey] = primaryNumber;
  }

  return values;
}

export function buildPremiumRows({
  direction,
  phase = "entry",
  buyPremium,
  sellPremium,
  fallback = "—",
  showEmptyRows = true,
}) {
  const primarySide = getPremiumPrimarySide(direction, phase);
  const values = {
    [BUY_SIDE]: toPremiumNumber(buyPremium),
    [SELL_SIDE]: toPremiumNumber(sellPremium),
  };

  return [primarySide, getOppositeSide(primarySide)].reduce((rows, side) => {
    const value = values[side];
    if (!showEmptyRows && value === null) return rows;

    rows.push({
      side,
      label: side === BUY_SIDE ? "Buy" : "Sell",
      value: formatPremiumValue(value, fallback),
      hasValue: value !== null,
      primary: side === primarySide,
    });

    return rows;
  }, []);
}

export function getDirectionalPremiumValue(direction, phase, pairValues) {
  const values = buildPremiumPairValues({
    direction,
    phase,
    buyPremium: pairValues?.buyPremium,
    sellPremium: pairValues?.sellPremium,
  });
  const primarySide = getPremiumPrimarySide(direction, phase);
  return primarySide === BUY_SIDE ? values.buyPremium : values.sellPremium;
}

export function hasNonZeroPremiumPair({ buyPremium, sellPremium }) {
  const buy = toPremiumNumber(buyPremium);
  const sell = toPremiumNumber(sellPremium);
  return (buy !== null && buy !== 0) || (sell !== null && sell !== 0);
}
